/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import { Link } from 'react-router-dom'
import { useFormik } from 'formik'
import { toAbsoluteUrl } from '../../../../_metronic/helpers'

const resetPasswordSchema = Yup.object().shape({
  password_1: Yup.string()
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
      'Ihr Passwort beinhaltet mindestens 8 Zeichen aus einem Mix mit Buchstaben, Zahlen & Zeichen.'
    )
    .required('Ihr Passwort beinhaltet mindestens 8 Zeichen mit einem Mix aus Buchstaben, Zahlen & Zeichen.'),
  password_2: Yup.string()
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
      'Ihr Passwort beinhaltet mindestens 8 Zeichen aus einem Mix mit Buchstaben, Zahlen & Zeichen.'
    )
    .required('Ihr Passwort beinhaltet mindestens 8 Zeichen mit einem Mix aus Buchstaben, Zahlen & Zeichen.'),
})

const initialValues = {
  password_1: 'Kevibr134813481?',
  password_2: 'Kevibr134813481?',
}

/*
  Formik+YUP+Typescript:
  https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
  https://medium.com/@maurice.de.beijer/yup-validation-and-typescript-and-formik-6c342578a20e
*/

export function ResetPassword() {
  const [loading, setLoading] = useState(false)
  const formik = useFormik({
    initialValues,
    validationSchema: resetPasswordSchema,
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      setLoading(true)

      let message = 'Bei der Datenverarbeitung ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.'

      try {
        /*
        const { data: loginData } = await login(values.password_1, values.password_2)

        // Since loginData.user is a string, it should be a valid argument for getUserById if it expects a user ID.
        if (loginData && loginData.user) {
          const { data: userData } = await getUserById(loginData.user.id)
          setCurrentUser(userData as UserModel | undefined)
        } else {
          setStatus('Die eingegebenen Zugangsdaten konnten keinem Konto zugeordnet werden.')
        }
        */
        setSubmitting(false)
        setLoading(false)

      } catch (error) {
        setStatus(message)
        setSubmitting(false)
        setLoading(false)
      }
    },
  })

  return (
    <form
      className='form w-100'
      onSubmit={formik.handleSubmit}
      noValidate
      id='opp_login_signin_form'
    >
      {/* begin::Heading */}
      <div className='text-left mt-lg-8 mb-8'>
        <img
          alt='Logo'
          className='h-40px logo theme-light-show mb-3 me-4'
          src={toAbsoluteUrl('/media/logos/favicon_partnerportal.png')}
        />
        <img
          alt='Logo'
          className='h-55px logo theme-light-show'
          src={toAbsoluteUrl('/media/logos/ofindo_logo_partnerportal.svg')}
        />
        <img
          alt='Logo'
          className='h-40px logo theme-dark-show mb-3 me-4'
          src={toAbsoluteUrl('/media/logos/favicon_partnerportal.png')}
        />
        <img
          alt='Logo'
          className='h-55px logo theme-dark-show'
          src={toAbsoluteUrl('/media/logos/ofindo_logo_partnerportal.svg')}
        />
      </div>
      {/* begin::Heading */}

      {/* begin::Title */}
      <h1 className='text-dark fw-bolder mb-3'>Anmelden</h1>
      {/* end::Title */}

      {
        formik.status && (
          <div className='alert alert-danger'>
            <div className='alert-text font-weight-bold'>{formik.status}</div>
          </div>
        )
      }

      {/* begin::Form group */}
      <div className='fv-row mb-3'>
        <label className='form-label fs-7 fw-bolder text-dark'>Passwort</label>
        <input
          type='password'
          autoComplete='off'
          {...formik.getFieldProps('password_1')}
          className={clsx(
            'form-control bg-transparent',
            {
              'is-invalid': formik.touched.password_1 && formik.errors.password_1,
            },
            {
              'is-valid': formik.touched.password_1 && !formik.errors.password_1,
            }
          )}
        />
        {formik.touched.password_1 && formik.errors.password_1 && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block small'>
              <span role='alert'>{formik.errors.password_1}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Form group */}
      <div className='fv-row mb-8'>
        <label className='form-label fs-7 fw-bolder text-dark'>Passwort</label>
        <input
          type='password'
          autoComplete='off'
          {...formik.getFieldProps('password_2')}
          className={clsx(
            'form-control bg-transparent',
            {
              'is-invalid': formik.touched.password_2 && formik.errors.password_2,
            },
            {
              'is-valid': formik.touched.password_2 && !formik.errors.password_2,
            }
          )}
        />
        {formik.touched.password_2 && formik.errors.password_2 && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block small'>
              <span role='alert'>{formik.errors.password_2}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Action */}
      <div className='d-grid'>
        <button
          type='submit'
          id='kt_sign_in_submit'
          className='btn btn-primary'
          disabled={formik.isSubmitting || !formik.isValid}
        >
          {!loading && <span className='indicator-label'>Speichern</span>}
          {loading && (
            <span className='indicator-progress' style={{ display: 'block' }}>
              Wird geladen ...
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
      </div>
      {/* end::Action */}
      <div className='separator separator-content my-10'>
        <span className='w-50px text-gray-500 fw-semibold fs-7'>oder</span>
      </div>
      <Link to='/auth/login'>
        <button
          type='button'
          id='kt_login_signup_form_cancel_button'
          className='btn btn-light-primary w-100'
        >
          Anmelden
        </button>
      </Link>
    </form >
  )
}
